import { createContext } from 'react'

import { UseFormControlProviderReturn } from './use-form-control'

export type FormControlContext = Partial<UseFormControlProviderReturn>

export const FormControlContext = createContext<FormControlContext>({})
